<template>
  <div class="">
    <SidePageColumn side="right">
      <div class="text-left">
        <template v-for="(menu_item, index) in sub_menu_items">
          <NavbarMenuItem
            v-if="can_access(menu_item)"
            :key="index"
            :to="menu_item.to"
            :icon="menu_item.icon"
            :label="menu_item.label"
          ></NavbarMenuItem>
        </template>
      </div>
      <v-divider
        class="mt-4"
        v-if="attrs.right_quick_links.length > 0"
      ></v-divider>
      <QuickSideLinks
        :quick_links="attrs.right_quick_links"
        v-if="attrs.right_quick_links.length > 0"
      ></QuickSideLinks>
    </SidePageColumn>
    <CenterNavbar
      :crumps="attrs.crumps"
      :title="attrs.title"
      :width_class="page_info.center_width_class"
      :show_staff="!show_banner"
      :navbar_cols="attrs.navbar_cols ? attrs.navbar_cols : 4"
    ></CenterNavbar>
    <div class="inner-page-container">
      <div
        v-if="show_banner"
        class="text-center white d-flex flex-column justify-space-between align-center"
      >
        <div class="pt-10">
          <v-img
            width="450"
            height="400"
            max-height="400"
            contain
            src="https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1605688003/botswana%20services/website%20assets/botswana-political-map_ywzvrz.jpg"
          >
          </v-img>
        </div>
        <p class="pa-10 text-h5 pb-0 pt-2 mb-15">
           View System and Activity Reports. <br/>
          <br />
          <br />
          <v-btn
            class="ma-1 mb-4"
            dense
            rounded
            outlined
            color="success"
            @click="go_to_registrations_report"
          >
            <v-icon left class="mobile-display-none">mdi-eye</v-icon>
            Registrations Report
          </v-btn>
          <v-btn
            class="ma-1 mb-4"
            dense
            rounded
            outlined
            color="success"
            @click="go_to_promotions_report"
          >
            <v-icon left class="mobile-display-none">mdi-eye</v-icon>
            Promotions Report
          </v-btn>
          <br /><br />
        </p>
      </div>
      <router-view
        :user="user"
        :is_loading="is_loading"
        @on-show-loader="$emit('on-show-loader')"
        @on-hide-loader="$emit('on-hide-loader')"
        @set-page-attributes="on_set_page_attributes"
        @set-missing-badge-count="val => $emit('set-missing-badge-count',val)"
      ></router-view>
    </div>
  </div>
</template>

<script>
import SidePageColumn from "./../../../components/SidePageColumn";
import QuickSideLinks from "./../../../components/QuickSideLinks";
import Utils from "./../../../lib/Utils";
import NavbarMenuItem from "./../../../components/NavbarMenuItem";
import CenterNavbar from "./../../../components/CenterNavbar";
import page_info from "./../../../lib/page_info";
export default {
  name: "AdminReports",
  components: {
    SidePageColumn,
    NavbarMenuItem,
    CenterNavbar,
    QuickSideLinks,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: false,
    },
  },
  data: () => {
    return {
      sub_menu_items: [
        {
          label: "RPT: Registrations",
          icon: "mdi-view-list",
          to: "/admin/reports/registrations",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "RPT: Promotions",
          icon: "mdi-plus-box",
          to: "/admin/reports/promotions",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "RPT: Overdue Promos",
          icon: "mdi-plus-box",
          to: "/admin/reports/overdue",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "RPT: Promos Views",
          icon: "mdi-plus-box",
          to: "/admin/reports/promoviews",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "RPT: BSNS Views",
          icon: "mdi-plus-box",
          to: "/admin/reports/views/activity",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "RPT: BSNS Searches",
          icon: "mdi-plus-box",
          to: "/admin/reports/searches/activity",
          roles: ["super role", "backofficcee"],
        },
        {
          label: "RPT: Advert Clicks",
          icon: "mdi-plus-box",
          to: "/admin/reports/adverts",
          roles: ["super role", "backofficcee"],
        },
      ],
      page_info: page_info,
      attrs: Utils.get_default_page_attr(),
    };
  },
  methods: {
    can_access(menu_item) {
      var res = Utils.can_access(this.user, menu_item);
      return res;
    },
    on_set_page_attributes(attrs) {
      if (attrs.right_quick_links) {
        this.attrs = attrs;
      } else {
        this.attrs = {
          ...attrs,
          right_quick_links: [],
        };
      }
    },
    go_to_registrations_report(){
        this.$router.push("/admin/reports/registrations");
    },
    go_to_promotions_report(){
        this.$router.push("/admin/reports/promotions");
    }
  },
  computed: {
    show_banner() {
      // console.log(this.$route.path);
      // console.log(this.$route.path == "/owner/missing");
      if (this.$route.path == "/admin/reports") {
        return true;
      }
      return false;
    },
  },
};
</script>